// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "ModuleHeader__textCenter__RsH4L";
export const moduleHeader = "ModuleHeader__moduleHeader__hHqD7";
export const noPadding = "ModuleHeader__noPadding__yeeqT";
export const responsive = "ModuleHeader__responsive__+jp2H";
export const title = "ModuleHeader__title__rMEPo";
export const subtitle = "ModuleHeader__subtitle__zlHW5";
export const blockName = "ModuleHeader__blockName__ZCfa2";
export const rightArrow = "ModuleHeader__rightArrow__+jNAl";
export const headerInner = "ModuleHeader__headerInner__06PH6";
export const tooltipIconWrapper = "ModuleHeader__tooltipIconWrapper__wyr2s";
export const withChevron = "ModuleHeader__withChevron__5OJ7X";
export const connected = "ModuleHeader__connected__Wq1qp";